import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':organizationContactId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:organizationContactId`;

export const URL = (organizationContactId: number): RouteDefinition => `${baseRoute}/${organizationContactId}`;
